import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
  Grid2,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../../components/MaterialButton";
import BASEURL from "../../../Utils/Baseurl";
import { useUserDetails } from "../../../../context/auth";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialSelect from "../../../../components/MasterSelect";
import { noticeperiodDaysOptions } from "../residnationData";
import MaterialInput from "../../../../components/MaterialInput";
import { updateMutationQuery } from "../GraphQl";
function ResignationApproval() {
  let tabdata = sessionStorage.getItem("resignationTap");
  let Roledata = JSON.parse(tabdata)
  const locatdatas = JSON.parse(sessionStorage.getItem("user"));
  const navigate = useNavigate();
  const {AccessData, HRLIST } = useUserDetails();
  const location = useLocation();
  const [employeeData, setemployeeData] = useState([]);  
  const[employeeId,setEmployeeId]= useState("");
  const [ID, setID] = useState("");
  const tabList = location?.state?.tabList;  
  const [ resignationDate, setResignationDate] = useState("");
  const [resignationData, setResignationData] = useState({
    noticeOption: "",
    noticeOptionStatus: "unchecked",
    dateOfResignation: "",
    dateOfResignationStatus: "unchecked"
  });
  const [Alldata, setAlldata] = useState("");
  const [display, setdisplay] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getemployeedata(id);
    }
  }, []);


  //Get Data By Id
  const getemployeedata = async (id) => {
    const query = ` query getResignationFormById($id:ID!){  
  getResignationFormById(id:$id){  
    id  
    employeeName  
    employeeId  
    user{
      id
    }
    designation  
    department  
    dateOfResignation  
    reason  
    otherReason  
   noticeOption 
    noticePeriod  
    teamApproval  
    teamApprovalDate  
    hrApproval  
    hrApprovalDate  
    waiveNotice 
    doNotWaiveNotice 
    replacementRequired 
    rehireRequired 
    status  
    createdAt  
  }  
} 
  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const leaveDatass = response.data.data.getResignationFormById;
      setAlldata(leaveDatass);
      setResignationDate(leaveDatass?.dateOfResignation);
      setEmployeeId(leaveDatass?.user?.id);
      setemployeeData(leaveDatass);
      if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "Resignation" &&
            item.component === "ManagerApproval" &&
            item.can_access
        )
      ) {

        if (leaveDatass.teamApproval == "Pending") {
          setdisplay(true);
        } else {
          setdisplay(false);
        }
      } else if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "Resignation" &&
            item.component === "HrApproval" &&
            item.can_access
        )
      ) {
        if (Roledata == "HRList") {
          if (leaveDatass.teamApproval == "Pending") {
            setdisplay(true);
          }
        } else if (Roledata == "HR") {
          if (
            leaveDatass.teamApproval == "approved" &&
            leaveDatass.hrApproval == "Pending"
          ) {
            setdisplay(true);
          }
        }
      }
    } catch (error) {
      console.error("ReponseError:", error);
    }
  };

  //Update Function
  const onEditResignation = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update the Details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        updateRsignation();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Update Mutation Function
  const updateRsignation = async () =>{
    try{
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query: updateMutationQuery,
          variables: {
            input: {
              id: ID,
              user: employeeId,
              noticeOption: resignationData?.noticeOption?.value,
              dateOfResignation: resignationData?.dateOfResignation,
              waiveNotice: false,
              doNotWaiveNotice: false,
              replacementRequired: false,
              rehireRequired: false,
            }
          }
        })
      });
      
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
       Swal.fire({
              position: "center",
              icon: "success",
              title: "Resignation Form Updated Successfully!",
              showConfirmButton: false,
              timer: 2500,
        });
    }
    catch(error){
      console.error("Error Submitting Data: ",error);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Enter Valid Data in Both Fields!",
        showConfirmButton: false,
        timer: 2500,
  });
    }
  }

  //Approval Function
  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the Resignation?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Approval Mutation Function
  const ApproveSubmit = async (statusdata) => {
    let query;
    let variables;
    //Team Approval
    if (employeeData?.teamApproval == "pending") {
      query = `
  mutation createresignationApprovalManager($input: CreateResignationApprovalManagerInput!) { 

  resignationApprovalManager(input: $input) { 

    success 

    message 

    error 

  } 

} 
  `;

      variables = {
        input:{
        id: ID + "",
        status: statusdata,
        approverId: locatdatas?.id,
        screenName: "Exit Formalities",
      }
  
      };
    } else {
      // HR approval
      query = `
  mutation CreateresignationApprovalHR($input: CreateResignationApprovalHRInput!) { 

  resignationApprovalHr(input: $input) { 

    success 

    message 

    error 

  } 

} 
  `;

      variables = {
        input:{
        id: +ID,
        status: statusdata,
        }
      };
    }

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: `${
          statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
        } successfully!`,
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/resignation-list");

      // Handle success (e.g., show a success message or navigate)
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      // Handle error (e.g., show a user-friendly error message)
    }
  };

  const handleclose = () => {
    navigate("/resignation-list");
  };

  //Handle Change
  const handleChange = (event, selectEvent) => {
    let resignationState = { ...resignationData};
    //Dropdown
    if(event?.target === undefined && selectEvent){
      switch(selectEvent.name){
        case "noticeOption":{
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{0,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            resignationState[selectEvent.name + "Status"] = "success";
          } else {
            resignationState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          break;
        }
      }
      resignationState[selectEvent.name] =event;
    }
    else if(event && event.target){
      //Input Field
      switch(event.target.name){
        case "dateOfResignation":{
          const value = event.target.value;
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{0,100})$");
          if (alphaNLenghthRegex.test(value)) {
            resignationState[event.target.name + "Status"] = "success";
          } else {
            resignationState[event.target.name + "Status"] = "error";
          }
          break;
        }
      }
      resignationState[event.target.name] = event.target.value;
    }
    setResignationData(resignationState);
  };


  
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 2, boxShadow: 3 }}>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold" textAlign="center">
                Resignation Details
              </Typography>
            </Stack>
          }
        />
        <CardContent>
        {AccessData?.some(
          (item) =>
            item?.component === "HrApproval" &&
            item?.module === "Resignation" 
        ) && employeeData?.teamApproval === "approved" && employeeData?.hrApproval === "pending" && 
        (
        <Grid2 container spacing={2}>
                  {/* <Grid2 size={{ xs: 12, sm: 6  }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Notice Period Days <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                      </MaterialBox>
                      <MaterialSelect
                      name="noticeOption"
                      value={resignationData?.noticeOption}
                      options={noticeperiodDaysOptions}
                      customStyles={{ optionPadding: 20 }}
                      onChange={handleChange}
                      error={
                        resignationData.noticeOptionStatus === "error" ? true : false
                      }
                      success={
                        resignationData.noticeOptionStatus === "success" ? true : false
                      }
                      />
                  </Grid2>
  
                  <Grid2 size={{ xs: 12, sm: 6  }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Last Working Date <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                      name="dateOfResignation"
                      value={resignationData.dateOfResignation}
                      onChange={handleChange}
                      type="date"/>
                  </Grid2> */}
                
          </Grid2>
          )}
                  {AccessData?.some(
            (item) =>
              item?.component === "HrApproval" &&
              item?.module === "Resignation" 
          ) && employeeData?.teamApproval === "approved" && employeeData?.hrApproval === "pending" && 
          (
                  <MaterialBox
                          mt={2}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center">
                              {/* <MaterialButton
                                variant="gradient"
                                color="dark"
                                onClick={onEditResignation}
                              >
                                Update
                              </MaterialButton> */}
                  </MaterialBox>
          )}
        
          <Grid container spacing={1} marginLeft={"4%"} mt={2}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.employeeName}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Department:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                  {employeeData.department}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Designation:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.designation}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Employee ID:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.employeeId}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Date of Resignation:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.dateOfResignation}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.reason}
                  </span>
                </Typography>

                <Typography variant="h6">
                  <strong>Notice Period:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.noticeOption}
                  </span>
                </Typography>
                
                <Typography variant="h6">
                  <strong>Team Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.teamApproval == "approved"
                      ? "Approved"
                      : employeeData?.teamApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.teamApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>HR Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.hrApproval == "approved"
                      ? "Approved"
                      : employeeData?.hrApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.hrApproval}
                  </span>
                </Typography>
              </Stack>
              
            </Grid>  
          
          </Grid>
         

          {/* Close and Action Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
      {/* Manager Approval */}
      {Roledata === "Team List" && AccessData?.some(
        (item) =>
          item?.component === "ManagerApproval" &&
          item?.module === "Resignation" 
      ) && employeeData?.teamApproval === "pending" && (
        <>
          <Grid item>
            <MaterialButton
              variant="contained"
              color="primary"
              onClick={() => handleAddLeave("approved")}
            >
              Approve
            </MaterialButton>
          </Grid>
          <Grid item>
            <MaterialButton
              variant="contained"
              color="secondary"
              onClick={() => handleAddLeave("rejected")}
            >
              Reject
            </MaterialButton>
          </Grid>
        </>
      )}

      {/* HR Approval */}
      {Roledata === "HR List" && AccessData?.some(
        (item) =>
          item?.component === "HrApproval" &&
          item?.module === "Resignation" 
      ) && employeeData?.teamApproval === "approved" && employeeData?.hrApproval === "pending" && (
        <>

      <Grid item>
      
        <MaterialButton
          variant="contained"
          color="primary"
          onClick={() => handleAddLeave("approved")}
        >
          Approve
        </MaterialButton>
      </Grid>
      <Grid item>
        <MaterialButton
          variant="contained"
          color="secondary"
          onClick={() => handleAddLeave("rejected")}
        >
          Reject
        </MaterialButton>
      </Grid>
    </>
  )}

  <Grid item>
    <MaterialButton
      variant="contained"
      color="dark"
      onClick={() => handleclose()}
    >
      Close
    </MaterialButton>
  </Grid>
</Grid>

        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default ResignationApproval;
